import PrimaryButton from "../../../components/Buttons/primary-button";
import {useNavigate} from "react-router-dom";

export default function FooterPracticeBanner() {
    const navigation = useNavigate();


    return (
        <div
            className="px-[12px] bg-[#F2DFC4] lg:pt-[45px]  flex justify-end items-center box-border pt-[18px] lg:px-[108px]">

            <div className={"flex flex-col   lg:flex-row justify-end items-center lg:gap-[61px]  "}>
                <div className={"flex flex-col gap-[48px]"}>
                    <div className={"flex flex-col gap-[12px] lg:gap-[24px]"}>
                        <p className={"font-semibold text-[24px] leading-[120%] lg:text-[38px]"}>
                            Ready to Reach Your Target Score? Join thousands of DET learners improving their results
                            with AI-powered practice.
                        </p>

                    </div>

                    <div className={"flex flex-row justify-between"}>
                        <PrimaryButton
                            onClick={() => navigation("/practice")}
                        >
                            Start Practicing Free
                        </PrimaryButton>


                    </div>
                </div>
                <img
                    src={"/images/woman.png"}
                    alt={"laptop-demo-image"}
                    className="lg:w-[488px] w-full h-auto lg:h-[500px]    object-bottom object-contain"
                />
            </div>
        </div>
    )
}